import type { LearnPracticalContent } from "../practicalContent.js";

export const chemicalsContent: LearnPracticalContent = {
  th: {
    notice: [
      "กลิ่นผิดปกติ ไอระเหย การระคายเคือง หรือภาชนะรั่ว อาจบ่งชี้การสัมผัสสารเคมี",
      "สารต่างชนิดต้องใช้วิธีตอบสนองต่างกัน จึงต้องดูฉลาก เอกสาร SDS และคำสั่งเหตุการณ์",
      "กลุ่มควันหรือเมฆสีผิดปกติ สัตว์ล้มป่วยพร้อมกัน หรือประกาศจากเจ้าหน้าที่อาจบ่งชี้เหตุสารเคมีภายนอก",
      "การใช้ผลิตภัณฑ์ทำความสะอาด ยาฆ่าแมลง สี กาว หรือเชื้อเพลิงในพื้นที่อับอากาศอาจเพิ่มไอระเหย แม้ภาชนะไม่รั่ว",
    ],
    prepare: [
      "เก็บผลิตภัณฑ์ในภาชนะเดิมพร้อมฉลาก และแยกจากอาหาร เด็ก และสัตว์",
      "รู้ว่าฉลากและเอกสารข้อมูลความปลอดภัยอยู่ที่ใด",
      "อย่าถ่ายสารลงขวดอาหารหรือเครื่องดื่ม และวางแผนอพยพหรือหลบในอาคารตามคำสั่ง",
      "เปิดอ่านฉลากก่อนซื้อและก่อนใช้ รวมทั้งเตรียมการระบายอากาศตามที่ฉลากระบุ โดยไม่ดัดแปลงวิธีใช้เอง",
    ],
    during: [
      "อย่าสัมผัสภาชนะที่รั่ว ให้ออกจากบริเวณและทำตามคำสั่งอพยพหรือหลบในอาคาร",
      "หากมีอาการผิดปกติ ให้ไปยังที่ปลอดภัยและขอความช่วยเหลือทางการแพทย์",
      "ถ้าเหตุอยู่กลางแจ้ง ให้ออกห่างและอยู่เหนือลมหากทำได้โดยปลอดภัย แล้วติดตามคำสั่งเจ้าหน้าที่",
      "หากคำสั่งให้หลบในอาคาร ให้เข้าพื้นที่ในอาคารตามคำสั่ง ปิดช่องเปิดตามที่เจ้าหน้าที่แนะนำ และติดตามการเปลี่ยนแปลงของคำสั่ง",
    ],
    avoid: [
      "อย่าผสมสาร ทำให้อาเจียน หรือใช้น้ำล้างโดยเดาเอง",
      "อย่าใช้ระยะปลอดภัยหรือหน้ากากแบบเดียวกับสารทุกชนิด",
      "อย่ากลับไปเก็บของหรือช่วยโดยไม่มีอุปกรณ์และการฝึก เพราะอาจเพิ่มผู้สัมผัสสาร",
      "อย่าเก็บผลิตภัณฑ์หลายชนิดรวมกันโดยไม่มีฉลากหรือใช้อุปกรณ์ครัวตวงสารเคมี",
    ],
    help: [
      "ขอความช่วยเหลือทันทีเมื่อหายใจลำบาก หมดสติ แสบร้อนรุนแรง หรือมีการรั่วไหลที่ควบคุมไม่ได้",
      "แจ้งชื่อผลิตภัณฑ์หรือแสดงฉลากแก่เจ้าหน้าที่ถ้าทำได้โดยไม่สัมผัสสาร",
      "บอกเจ้าหน้าที่ว่าสัมผัสทางผิวหนัง ตา การหายใจ หรือการกลืนเท่าที่ทราบ โดยไม่คาดเดาชนิดสาร",
      "ขอคำแนะนำจากผู้เชี่ยวชาญหรือฉลากผลิตภัณฑ์ก่อนทำความสะอาดหรือกำจัดสิ่งของหลังเหตุ เพราะวิธีที่เหมาะสมขึ้นกับสารนั้น",
    ],
    example:
      "พบภาชนะไม่ทราบชนิดรั่วและมีกลิ่นฉุน: ไม่เข้าไปแตะหรือสูดใกล้ ๆ ออกจากบริเวณ แล้วทำตามคำสั่งเจ้าหน้าที่สำหรับเหตุและสารนั้นโดยเฉพาะ",
    situations: [
      {
        title: "ทำความสะอาดบ้าน",
        text: "อ่านฉลากก่อนใช้ เปิดการระบายอากาศตามคำแนะนำ และไม่ผสมผลิตภัณฑ์แม้คิดว่าช่วยให้สะอาดเร็วขึ้น",
      },
      {
        title: "ภาชนะไม่มีฉลาก",
        text: "อย่าดมหรือทดลองใช้เพื่อระบุชนิดสาร แยกคนและสัตว์ออกจากพื้นที่ แล้วขอคำแนะนำที่เหมาะกับเหตุ",
      },
      {
        title: "เหตุใกล้ชุมชน",
        text: "เมื่อเห็นควันหรือได้รับประกาศ ให้ทำตามคำสั่งอพยพหรือหลบในอาคารของหน่วยงาน ไม่ขับรถเข้าใกล้เพื่อดูเหตุ",
      },
    ],
    checklist: [
      "อ่านฉลากก่อนใช้",
      "เก็บในภาชนะเดิม",
      "ไม่ผสมสารโดยเดา",
      "ออกห่างจากการรั่วไหล",
      "บอกข้อมูลฉลากแก่เจ้าหน้าที่",
      "ใช้ตามฉลากและระบายอากาศตามคำแนะนำ",
      "แยกสารเคมีออกจากอาหารและอุปกรณ์ครัว",
    ],
  },
  en: {
    notice: [
      "An unusual smell, vapour, irritation, or leaking container may indicate chemical exposure.",
      "Different substances require different responses; use the label, SDS, and incident instructions.",
      "An unusual cloud, several suddenly ill animals, or an authority alert may indicate an outdoor chemical release.",
      "Using cleaners, pesticides, paint, glue, or fuel in a poorly ventilated area can increase vapour exposure even when a container is not leaking.",
    ],
    prepare: [
      "Keep products in their original labelled containers, away from food, children, and animals.",
      "Know where labels and safety data sheets can be found.",
      "Never transfer chemicals into food or drink containers, and plan how to evacuate or shelter when directed.",
      "Read the label before buying and before using a product, and arrange ventilation as directed without improvising a different method.",
    ],
    during: [
      "Do not touch a leaking container; leave the area and follow evacuation or shelter instructions.",
      "If symptoms develop, get to a safer place and seek medical help.",
      "For an outdoor release, move away and stay upwind when this can be done safely, then follow responder instructions.",
      "If told to shelter indoors, enter the building area specified, close openings as responders direct, and keep monitoring for changed instructions.",
    ],
    avoid: [
      "Do not mix substances, induce vomiting, or improvise washing instructions.",
      "Do not assume one distance or mask works for every chemical.",
      "Do not return for belongings or attempt a rescue without training and protective equipment.",
      "Do not store multiple products together without labels or use kitchen utensils to measure chemicals.",
    ],
    help: [
      "Get urgent help for breathing difficulty, unconsciousness, severe burning, or an uncontrolled release.",
      "Give responders the product name or label only when it can be done without exposure.",
      "Tell responders whether exposure may have involved skin, eyes, breathing, or swallowing, but do not guess the substance.",
      "Ask a professional or follow the product information before cleaning up or discarding items after an incident; the safe method depends on the substance.",
    ],
    example:
      "An unidentified container leaks with a sharp smell: do not touch it or move closer to identify it. Leave the area and follow incident-specific instructions from responders.",
    situations: [
      {
        title: "Home cleaning",
        text: "Read the label, use the directed ventilation, and do not mix products even if you think this will clean faster.",
      },
      {
        title: "Unlabelled container",
        text: "Do not smell or test it to identify the substance. Keep people and animals away and seek incident-appropriate advice.",
      },
      {
        title: "Nearby community incident",
        text: "When you see smoke or receive an alert, follow evacuation or shelter instructions from authorities; do not drive closer to watch.",
      },
    ],
    checklist: [
      "Read the label first",
      "Keep the original container",
      "Never guess about mixing",
      "Move away from a release",
      "Give label details to responders",
      "Use as labelled with the directed ventilation",
      "Keep chemicals separate from food and kitchen tools",
    ],
  },
};
